module.exports = __webpack_public_path__ + "img/health_center_documents.7b6a8a4b.jpg";